import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/styles.css";
import '../../css/index.css';
import { useRef } from 'react';
import subteams from "./../../components/Subteams";
import Carousel from 'react-bootstrap/Carousel';
import first from "./20250421.mp4";
import second from "./20250414.mp4";
import third from "./20250408.mp4";

import "./Contact.scss";

export default function Contact() {

  useEffect(() => {
    const INSTAGRAM_SCRIPT_SRC = "https://www.instagram.com/embed.js";

    const processInstagramEmbeds = () => {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
      }
    };

    const existingScript = document.querySelector(
      `script[src="${INSTAGRAM_SCRIPT_SRC}"]`
    );

    if (existingScript) {
      if (window.instgrm && window.instgrm.Embeds) {
        processInstagramEmbeds();
      } else {
        existingScript.addEventListener("load", processInstagramEmbeds, {
          once: true,
        });
      }

      return () => {
        existingScript.removeEventListener("load", processInstagramEmbeds);
      };
    }

    const script = document.createElement("script");
    script.src = INSTAGRAM_SCRIPT_SRC;
    script.async = true;
    script.addEventListener("load", processInstagramEmbeds, { once: true });
    document.body.appendChild(script);

    return () => {
      script.removeEventListener("load", processInstagramEmbeds);
    };
  }, []);
  const formRef = useRef(null);
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "Do I need prior experience to join M-Fly?",
      answer: "No prior experience is necessary! We welcome students from all backgrounds and skill levels. Our experienced members are happy to teach and mentor new members."
    },
    {
      id: 2,
      question: "What time commitment is required?",
      answer: "The time commitment varies depending on your role and the project timeline. Generally, members contribute 2-5 hours per week, with more time required closer to competition dates."
    },
    {
      id: 3,
      question: "What majors are represented on the team?",
      answer: "While many of our members are engineering students, we welcome all majors! We have members from aerospace, mechanical, electrical, computer science, business, and more."
    },
    {
      id: 4,
      question: "When can I join M-Fly?",
      answer: "We recruit at the beginning of each fall and winter semester. Keep an eye on our Instagram and attend Festifall/Winterfest to learn more about joining!"
    },
    {
      id: 5,
      question: "What competitions does M-Fly participate in?",
      answer: "M-Fly competes in the SAE Aero Design Regular Class and Advanced Class, as well as the Robonation SUAS competition."
    }
  ];

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };
  return (
    <>
      <Helmet>
        <title>Get Involved |M-Fly</title>
      </Helmet>
      <div className="Contact">
        <div className="white-div">
          <h1 className="text-center">Our Subteams</h1>
          <p className="subteam-description description-center">
            Each of our aircraft programs has a dedicated set of subteams which
            focus on various aspects of aircraft design, manufacturing, and
            testing. Some subteams play an integral role in all three aircraft
            programs, where others serve a mission-specific purpose for one or
            two of the programs.
          </p>
          <ul className="subteam-container">
            {subteams.map(({ name, image, description, link }) => (
              <li className="subteam-item" key={name}>
                <div className="subteam">
                  <img src={image} alt={name} className="subteam-image" />
                  <h4 className="subteam-title">{name}</h4>
                  <p className="subteam-text">{description}</p>
                  <a href={link} target="_blank" rel="noopener noreferrer" className="subteam-link">Learn More</a>
                </div>
              </li>
            ))}
          </ul>

        </div>
        <div className="blue-div">
          <h1 className="text-center">Manufacturing</h1>
          <Carousel className="carousel">
            <Carousel.Item interval={10000}>
              <video src={first} autoPlay muted loop className="d-block w-100" controls>
              </video>
              <Carousel.Caption>
                <h3>April 21, 2025</h3>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item interval={10000}>
              <video src={second} autoPlay muted loop className="d-block w-100" controls>
              </video>
              <Carousel.Caption>
                <h3>April 14, 2025</h3>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item interval={10000}>
              <video src={third} autoPlay muted loop className="d-block w-100" controls>
              </video>
              <Carousel.Caption>
                <h3>April 8, 2025</h3>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
        <div className="white-div calendar-section">
          <h1 className="text-center">Meetings & Events</h1>
          <iframe src="https://calendar.google.com/calendar/embed?src=umich.edu_r7lpifab9c81kiojs6dg2vje2g%40group.calendar.google.com&ctz=America%2FDetroit"
            style={{ border: 0, marginBottom: 30 }} width="100%" height="600" frameBorder="0" scrolling="no"></iframe>
        </div>
        <div className="blue-div faq-section">
          <h1 className="text-center">FAQ</h1>
          <div className="faq-container">
            {faqs.map((faq) => (
              <div key={faq.id} className="faq-item">
                <div 
                  className="faq-question" 
                  onClick={() => toggleFAQ(faq.id)}
                >
                  <h3>{faq.question}</h3>
                  <span className={`faq-icon ${openFAQ === faq.id ? 'open' : ''}`}>▼</span>
                </div>
                {openFAQ === faq.id && (
                  <p className="faq-answer">{faq.answer}</p>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="white-div instagram-contact-container">
          <div className="instagram-section">
            <blockquote
              className="instagram-media"
              data-instgrm-permalink="https://www.instagram.com/mfly_umich/"
              data-instgrm-version="14"
              style={{
                background: "#FFF",
                border: 0,
                borderRadius: 3,
                boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)",
                margin: "1px",
                maxWidth: 800,
                minWidth: 326,
                padding: 0,
                width: "99.375%",
                height: "100%"
              }}
            >
              <a
                href="https://www.instagram.com/mfly_umich/"
                target="_blank"
                rel="noreferrer"
              >
                View this profile on Instagram
              </a>
            </blockquote>
          </div>
          <div className="contact-form-section">
            <h1 className='text-center'>Contact Us</h1>
            <div className="">
              <form ref={formRef} action="https://api.web3forms.com/submit" method="POST" className="contacting">
                <input type="hidden" name="access_key" value="259247cf-d4b1-4ee9-9f59-4e77e96dfcb1" /> {/*get new api-key @ https://web3forms.com/ and put it in value*/}
                <input type="text" name="name" placeholder="Your Name" className="contact-inputs" required />
                <input type="email" name="email" placeholder="Your Email" className="contact-inputs" required />
                <textarea name="message" placeholder="Your Message" className="contact-inputs message-box" required></textarea>
                <div className="button-wrapper">
                  <button
                    type="primary"
                    className="submit-button contact-button"
                    onClick={() => formRef.current?.requestSubmit()}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
              <a href="https://forms.gle/HvMKgtZzHfmvTUNA6" target="_blank" rel="noopener noreferrer" className="newsletter-link">
                Subscribe to our Newsletter!
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
